import { size } from 'lodash';

export default {
    buttons: {
        start: '开始',
        end: '结束活动',
        submit: '提交',
        next: '下一题',
        result: '查看结果',
        nextModule: '下一个',
        selfDone: '自习完成',
        taskDone: '作业完成',
        moduleStart: '开始活动',
    },
    teacher: {
        setting: '活动设置',
        wayOfProgress: '进行方式',
        wayOfReading: '阅读方式',
        title: '活动标题',
        guide: '活动指南',
        tooltip: `
        <span class="tooltip_list">
            <strong>与老师一起</strong>
            <span>与老师一起逐题进行</span>
         </span>
         <span class="tooltip_list">
            <strong>自主学习</strong>
            <span>学生按照自己的速度完成所有题目</span>
        </span>
        `,
        screen: '活动画面',
        content: ({ values }: { values: { title?: string } }) => {
            const { title } = values;
            if (title) {
                return `活动内容 <span>${title}</span>`;
            }
            return '活动内容';
        },
        summary: '活动摘要',
    },
    alert: {
        wrong: '哎呀，答错了。请再试一次。',
        waiting: () => {
            const messages = ['完成了！请稍等一下。', '很好！请稍等一下。', '做得好！请稍等一下。'];
            return messages[Math.floor(Math.random() * size(messages))];
        },
    },
    question: '题目',
    answerRate: '正确率',
    relation: '{relation} 关系',
    allDone: '所有题目都已完成。请结束活动！',
    champion: '冠军',
    allSelect: '全部选择',
    majorVocabulary: '主要词汇',
    remainingVocabulary: '其他词汇',
    students: {
        errorTooltip: '学生处于离线状态',
        progress: {
            title: ({ values }: { values: { isOngoing: boolean } }) => {
                const { isOngoing } = values;
                return `每位学生的${isOngoing ? '状态' : '结果'}`;
            },
        },
        standby: '进行前',
        notAttended: '未参与',
        inProgress: '进行中',
        notCompleted: '未完成',
        completed: '已完成',
    },
    modal: {
        title: '结束活动',
        message: '要结束活动吗？',
    },
    state: {
        correct: '正确',
        wrong: '错误',
    },
    toast: {
        addStarStudent: '已给 {name} 赠送表扬星',
        addAllStar: '已给全体学生（{length}名）赠送表扬星',
        failedStar: '表扬星赠送失败',
        undo: '撤销',
        undoFailed: '撤销表扬星失败',
    },
};
